import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PreferenceService } from '../../services/preference.service';
import { environment } from 'src/environments/environment';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})

export class ContactsComponent implements OnInit, OnDestroy {
  code: string;
  companyIndex: string;
  actionType: string;
  message: string;
  title: any;
  text: any;
  loginPage = 'https://orbitax.com';
  constructor(
    private httpClient: HttpClient,
    private fuseSplashScreenService: FuseSplashScreenService,
    protected activatedRoute: ActivatedRoute,
    private preferenceService: PreferenceService) { }

  ngOnInit(): void {
    if (environment.dynamicsettings['DashboardUrl']) {
      this.loginPage = environment.dynamicsettings['DashboardUrl'];
      console.log('LogIn Url found - ' + this.loginPage);
    } else {
      console.log('LogIn Url Not found from Configuration');
      console.log(environment.dynamicsettings['DashboardUrl']);
    }
    this.code = '';
    this.companyIndex = '';
    this.actionType = '';

    if (this.activatedRoute.snapshot.queryParams['code']) {
      this.code = this.activatedRoute.snapshot.queryParams['code'];
    }
    if (this.activatedRoute.snapshot.queryParams['companyindex']) {
      this.companyIndex = this.activatedRoute.snapshot.queryParams['companyindex'];
    }
    if (this.activatedRoute.snapshot.queryParams['actiontype']) {
      this.actionType = this.activatedRoute.snapshot.queryParams['actiontype'];
    }
    console.log(this.code + ' -> ' + this.companyIndex + ' -> ' + this.actionType);

    if (this.code && this.companyIndex && this.actionType) {

      const acceptEmailUrl = 
      `${environment.dynamicsettings['PlatformApi']}AcceptEmail?code=${this.code}&companyIndex=${this.companyIndex}`;
      const rejectEmailUrl = 
      `${environment.dynamicsettings['PlatformApi']}RejectEmail?code=${this.code}&companyIndex=${this.companyIndex}`;
      const unsubscribeNotificationUrl = 
      `${environment.dynamicsettings['PlatformApi']}UnsubscribeNotification?code=${this.code}&companyIndex=${this.companyIndex}`;

      let url: string;

      if (this.actionType === 'accept') {
        url = acceptEmailUrl;
      }
      if (this.actionType === 'reject') {
        url = rejectEmailUrl;
      }
      if (this.actionType === 'unsubscribe') {
        url = unsubscribeNotificationUrl;
      }
      const httpOptions = this.preferenceService.getHttpOptions();
      httpOptions.headers = httpOptions.headers.set('ApiName', 'ContactsApi');
      this.httpClient.get<any>(url, httpOptions).subscribe((x: any) => {
        this.title = x.title;
        this.message = x.message;
        this.fuseSplashScreenService.hide();
        console.log(x.accepted + '->' + x.magicLink);
      },
        error => {
          console.log('Exception occurred while getting message!');
        });
    }
  }

  getUrlParam(name): string {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);

    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || '0';
    }
  }
  ngOnDestroy(): void {
  }
}
